import { schema, types } from 'papr'

export const badgeSchema = schema({
	title: types.string(),
	name: types.string({ required: true }),
	displayName: types.string({ required: true }),
	infoUrl: types.string(),
	image: types.string({ required: true }),
	description: types.string(),
})

export type BadgeDocument = (typeof badgeSchema)[0]
export type BadgeSchemaOptions = (typeof badgeSchema)[1]
